export type NamedStudy = {
  id: string
  name: string
}

export function selectSingleNamedStudy<TStudy extends NamedStudy>(
  studies: readonly TStudy[],
  name: string,
  preferredId?: string
) {
  const matches = studies.filter((study) => study.name === name)
  const primary = matches.find((study) => study.id === preferredId) ?? matches[0] ?? null

  return {
    primary,
    duplicates: primary ? matches.filter((study) => study.id !== primary.id) : [],
  }
}
